module.exports = __webpack_public_path__ + "img/title17.5fd5c0a1.png";